// extracted by mini-css-extract-plugin
export default {"element":"Table_element__-gvNq"};